<template>
  <el-dialog ref="dialog" title="高级筛选" size="large">
    <el-row style="text-align: left">
      <el-col v-for="(filter, index) in tempAdvanceFilter" :span="12" v-if="isHalf(filter.type) &&tempFilterData.length" >
        <div class="m-t-10 h-40">
          <label class="el-form-item__label inline-block w-80">{{filter.name}}</label>
          <el-input
            class="h-40 w-200"
            :placeholder="filter.name"
            v-model="tempFilterData[index].value"
            v-if="filter.type == FILTER_INPUT">
          </el-input>
          <el-select
              :placeholder="filter.name"
              :multiple="filter.is_multiple == 1"
              :filterable="true"
              clearable
              v-model="tempFilterData[index].value"
              v-if="filter.type == FILTER_SELECT">
            <el-option
                v-for="option in filter.field_config.select_option"
                :key="option"
                :label="option.name"
                :value="option.value">
            </el-option>
          </el-select>
          <range-filter
              :placeholder="filter.name"
              v-model="tempFilterData[index]"
              v-if="filter.type == FILTER_RANGE"
              class="inline-block">
          </range-filter>
          <datetimerange-filter
              :placeholder="filter.name"
              v-model="tempFilterData[index].value"
              v-if="filter.type == FILTER_DATERANGE"
              class="inline-block">
          </datetimerange-filter>
          <el-select
              :placeholder="filter.name"
              :filterable="true"
              clearable
              v-model="tempFilterData[index].value"
              v-if="filter.type == FILTER_FOREIGNKEY">
            <el-option
                v-for="option in filter.keyOptions"
                :key="option"
                :label="option.name"
                :value="option.id">
            </el-option>
          </el-select>
        </div>
        
      </el-col>
      <el-col v-for="(filter, index) in tempAdvanceFilter" :span="24" v-if="!isHalf(filter.type) && tempFilterData.length" class="m-t-10">
        <label class="el-form-item__label inline-block w-80" style="float: left !important;">{{filter.name}}</label>
        <div v-if="filter.type == FILTER_CHECKBOX ">
          <el-checkbox 
            v-model="tempFilterData[index].checked" 
            @change="change(filter.field_config.select_option, tempFilterData[index], index)" 
            class="fl m-l-20 m-r-10 m-t-10">
            全选
          </el-checkbox>
          <el-checkbox-group 
          v-model="tempFilterData[index].value" 
          class="m-l-10"
          @change="handleCheckedChange(index, filter.field_config.select_option)">
            <el-checkbox 
              class="m-t-10"
              v-for="option in filter.field_config.select_option" 
              :label="option.value">
              {{option.name}}
            </el-checkbox>
          </el-checkbox-group>
        </div>

        <div v-if="filter.type == FILTER_FOREIGNKEYCHECKBOX">
          <div v-if="isEach(filter.key_name)" style="margin-left: 80px;">
            <el-checkbox 
              v-model="tempFilterData[index].checked"
              @change="changeForeignEach(filter, filter.field_config.select_option, tempFilterData[index], index)" 
              class="m-l-20 m-r-10 m-t-10">
              全选
            </el-checkbox>
            <el-checkbox-group v-model="tempFilterData[index].value" class="m-l-20">
              <checkbox-demo 
                ref="checkboxDemo"
                @isAll="isAll"
                v-model="tempFilterData[index].value"
                :index="index"
                :options="filter.field_config.select_option" 
                :level="1">
              </checkbox-demo>
            </el-checkbox-group>
          </div>
          <div v-else>
            <el-checkbox 
              v-model="tempFilterData[index].checked" 
              @change="changeForeign(filter.field_config.select_option, tempFilterData[index], index)" 
              class="fl m-l-20 m-r-10 m-t-10">
              全选
            </el-checkbox>
            <el-checkbox-group 
            v-model="tempFilterData[index].value" 
            class="m-l-10"
            @change="handleCheckedChange(index, filter.field_config.select_option)">
              <el-checkbox
                class="m-t-10"
                v-for="option in filter.field_config.select_option" 
                :label="option.id">
                {{option.name}}
              </el-checkbox>
            </el-checkbox-group>
          </div>
        </div>
      </el-col>
    </el-row>
    <div class="footer">
      <el-button @click="closeDialog()">取消</el-button>
      <el-button type="primary" @click="submitData()">搜索</el-button>
    </div>
  </el-dialog>
</template>
<script>
  import http from '../../../assets/js/http'
  import rangeFilter from '../../Common/business/filter/rangeFilter'
  import cmsConfig from '../../../config/cmsConfig'
  import checkboxDemo from './checkboxDemo'
  import datetimerangeFilter from '../../Common/business/filter/datetimerangeFilter'
  export default {
    props: {
      advanceFilter: {
        type: Array,
        default() {
          return []
        }
      },
      filterData: {
        type: Array
      }
    },
    data() {
      return {
        tempFilterData: [],
        tempAdvanceFilter: []
      }
    },
    methods: {
      open() {
        this.setTempFilter()
        this.setTempAdvanceFilter()
        this.$refs.dialog.open()
      },
      closeDialog() {
        this.$refs.dialog.close()
      },
      isHalf(type) {
        if (type == this.FILTER_CHECKBOX || type == this.FILTER_FOREIGNKEYCHECKBOX) {
          return false
        } else {
          return true
        }
      },
      isEach(name) {
        if (name) {
          return true
        } else {
          return false
        }
      },
      getEachVal(child, value) {
        // let curVals = []
        _(child).forEach((res) => {
          value.push(res.id)
          if (res.child) {
            value = this.getEachVal(res.child, value)
          }
        })
        return value
      },
      isAll(exist, index) {
        // console.log('exist: ' + exist)
        if (exist) {
          this.tempFilterData[index].checked = false
        }
        if (this.tempAdvanceFilter[index]['valLen'] == this.tempFilterData[index]['value'].length) {
          this.tempFilterData[index].checked = true
        }
      },
      changeForeignEach(filter, filterOption, item, index) {
        let value = []
        if (item.checked) {
          value = this.getEachVal(filterOption, value)
          item.value = value
          this.$set(this.tempFilterData, index, item)
        }
      },
      changeForeign(filterOption, item, index) {
        let value = []
        if (item.checked) {
          _(filterOption).forEach((res) => {
            value.push(res.id)
          })
          item.value = value
          this.$set(this.tempFilterData, index, item)
        }
      },
      change(filterOption, item, index) {
        let value = []
        if (item.checked) {
          _(filterOption).forEach((res) => {
            value.push(res.value)
          })
          item.value = value
          this.$set(this.tempFilterData, index, item)
        }
      },
      handleCheckedChange(index, options) {
        // console.log(this.tempFilterData[index].value)
        let checkedLen = this.tempFilterData[index].value.length
        let optionsLen = options.length
        if (checkedLen < optionsLen) {
          this.tempFilterData[index].checked = false
        } else {
          this.tempFilterData[index].checked = true
        }
      },
      submitData() {
        // console.log(this.tempFilterData)
        this.$emit('handleAdvance', this.tempFilterData)
        this.$refs.dialog.close()
      },
      setTempFilter() {
        this.tempFilterData = _.cloneDeep(this.filterData)
      },
      setTempAdvanceFilter() {
        // console.log(this.advanceFilter)
        this.tempAdvanceFilter = _.cloneDeep(this.advanceFilter)
        _(this.tempAdvanceFilter).forEach((item) => {
          if (item.type == this.FILTER_FOREIGNKEYCHECKBOX) {
            if (item.key_name) {
              // 有选父级ID
              this.apiPost(`form/keys/${item.field_id}/${item.key_name}`).then((res) => {
                if (res.code == 200) {
                  item.field_config.select_option = res.data
                  // console.log(res.data)
                  let value = []
                  value = this.getEachVal(item.field_config.select_option, value)
                  item.valLen = value.length
                } else {
                  _g.dealError(this, res)
                }
              })
            } else {
              // 无选父级ID
              this.apiPost(`form/keys/${item.field_id}`).then((res) => {
                if (res.code == 200) {
                  item.field_config.select_option = res.data.marjorData
                } else {
                  _g.dealError(this, res)
                }
              })
            }
          }
        })
        // console.log(this.tempAdvanceFilter)
      }
      // async getForeignKeyCheckboxData(item, index) {
      //   let arr = []
      //   let extra_field = []
      //   if (item.key_name) {
      //     extra_field.push(item.key_name)
      //   }
      //   let postData = {
      //     extra_field: extra_field
      //   }
      //   // this.apiPost(`form/keys/${item.field_id}`, postData).then((res) => {
      //   //   if (res.code == 200) {
      //   //     console.log(res.data)
      //   //   } else {
      //   //     _g.dealError(this, res)
      //   //   }
      //   // })
      //   let res = await this.apiPost(`form/keys/${item.field_id}`, postData)
      //   return this.promiseHandler(arr, res)
      // }
    },
    components: {
      rangeFilter,
      checkboxDemo,
      datetimerangeFilter
    },
    mixins: [http, cmsConfig]
  }
</script>


// WEBPACK FOOTER //
// advanceDialog.vue?0bf676c2